export const addDays = (days, date) => {
  var newdate = new Date(date)
  newdate.setDate(newdate.getDate() + days)
  return newdate
}
